<template>
    <v-row>
      <v-col cols="12">
        <shipments-list :print="print" :pendings="pendings" @itemSelected="itemSelected"></shipments-list>
      </v-col>
      <v-dialog v-model="isDetailDialogOpen" persistent>
        <shipment-detail
          :shipmentId="shipmentSelected.shipmentId"
          @close="closeDetail"
          :print="print"
          :shipmentStatus="shipmentSelected.shipmentStatus"
          >
        </shipment-detail>
      </v-dialog>
    </v-row>
</template>

<script>
import ShipmentsList from '../shipments/ShipmentsList'
import ShipmentDetail from './ShipmentDetail'
import { loading, showMessage } from '../../../mixins'
import { saveAs } from 'file-saver'

export default {
  name: 'ShipmentsWrapper',
  props: {
    print: {
      type: Boolean,
      default: false
    },
    pendings: {
      type: Boolean,
      default: false
    }
  },
  mixins: [loading, showMessage],
  components: { ShipmentsList, ShipmentDetail },
  data: () => ({
    isDetailDialogOpen: false,
    shipmentSelected: {}
  }),
  methods: {
    itemSelected (item, action) {
      this.shipmentSelected = Object.assign({}, item)

      switch (action) {
        case 'detail': {
          this.isDetailDialogOpen = true
          break
        }
        case 'print': {
          this.downloadLabel()
          break
        }
      }
    },
    closeDetail () {
      this.isDetailDialogOpen = false
      this.shipmentSelected = {}
    },
    downloadLabel () {
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/edi/shipments/${this.shipmentSelected.shipmentId}/label`)
        .then((r) => {
          saveAs(r.data, `Shipment-${this.shipmentSelected.shipmentId}.pdf`)
        })
        .catch((e) => {
          console.log(e)
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    }
  }
}
</script>

<style>
